import { render, staticRenderFns } from "./NotificationListDoc.vue?vue&type=template&id=16991422"
import script from "./NotificationListDoc.vue?vue&type=script&lang=js"
export * from "./NotificationListDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationListDoc.vue?vue&type=style&index=0&id=16991422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports